<template>
  <div class="sponsors">
    <HeaderParticipant 
        :participants="participants" 
        :participant="participant" 
        @selectParticipants="selectParticipants" 
        @changeSelect="changeSelect"
    />
    <v-row :class="{ 'mt-4': !age18 }">
      <v-col cols="12" md="12" sm="12">
        <v-dialog v-model="dialog" max-width="600px">
          <v-card>
            <v-form ref="form">
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-row no-gutters class="mt-2">
                  <v-col md="12" cols="12">
                    <v-text-field
                      v-model="form.name"
                      :label="$t('sponsors.name')"
                      :rules="rules.name"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col md="12" cols="12">
                    <v-text-field
                      v-model="form.website"
                      :label="$t('sponsors.website')"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col md="6" cols="12">
                    <v-text-field
                      v-model="form.year"
                      :label="$t('sponsors.year')"
                      type="number"
                      class="mr-md-1"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col md="6" cols="12">
                    <v-text-field
                      v-model="form.contact"
                      :label="$t('sponsors.contact')"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  @click="dialog = false"
                  :color="`${buttonColor}`"
                  class="btn mb-2 mr-2"
                >{{ $t('sponsors.cancel') }}</v-btn>
                <v-btn
                  @click="createSponsor"
                  :color="`${buttonColor}`"
                  class="btn mb-2"
                  :disabled="!sponsorFormIsValid"
                >{{ $t('sponsors.save') }}</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="600px">
          <v-card>
            <v-card-title class="headline">{{ $t('sponsors.delete_sponsor') }}</v-card-title>
            <v-card-text>
              <p class="mt16">{{ $t('sponsors.sure_delete') }}</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="btn mb-2 mr-2" :color="`${buttonColor}`" @click="closeDelete">{{ $t('sponsors.cancel') }}</v-btn>
              <v-btn
                :color="`${buttonColor}`"
                class="btn mb-2"
                @click="deleteItemConfirm"
              >{{ $t('sponsors.delete') }}</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div v-for="part in participantList" :key="part.id" class="ml-2 mr-2 mb-2">
          <v-card class="elevation-4" :style="`background:${cardBGColor}`">
            <v-card-text>
              <v-row no-gutters>
                <v-col md="6" class="text-left" style="position:relative">
                  <HeaderCard :part="part" />
                </v-col>
                <v-col md="6" class="text-right">
                  <v-btn
                    :color="`${buttonColor}`"
                    dark
                    @click="openDialogCreate(part.userId)"
                  >{{ $t("sponsors.create_sponsor") }}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12">
                  <v-data-table
                    :headers="sponsorHeaders"
                    :items="part.sponsors"
                    sort-by="name"
                    class="elevation-1"
                    :no-data-text="$t('sponsors.no_data_available')"
                    :footer-props="{
                      'items-per-page-text': $t('sponsors.items_per_page_text'),
                      'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                    }" 
                    dense
                    :headerProps="{
                      'sort-by-text': $t('dataTable.sortByText')
                    }"
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon small class="mr-2" @click="editItem(item)">fa far fa-pencil-alt</v-icon>
                      <v-icon small @click="deleteItem(item)">fa far fa-trash-alt</v-icon>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
  </div>
</template>

<script>
import SponsorService from "../services/SponsorService";
import AuthService from "../services/AuthService";
import Snack from "../components/notifications/Snack";
import { VCard, VCol, VRow, VBtn, VIcon, VTextField, VCardText, VForm, VDialog, VDataTable, 
         VCardTitle, VCardActions, VSpacer } from 'vuetify/lib';
import GeneralService from "@/services/GeneralService";
import HeaderCard from "@/components/HeaderCard";
import { mapState } from "vuex";
import HeaderParticipant from "@/components/HeaderParticipant";

export default {
  name: "Sponsors",
  components:{
    Snack,
    VCard, VCol, VRow, VBtn, VIcon, VTextField, VCardText, VForm, VDialog, VDataTable,
    VCardTitle, VCardActions, VSpacer,  
    HeaderCard, HeaderParticipant
  },
  data() {
    const sponsorForm = Object.freeze({
      name: "",
      website: "",
      year: null,
      contact: "",
      userId: 0
    });
    return {
      snackbar: false,
      msg_snackbar: "",
      color_snackbar: "",
      dialog: false,
      editedIndex: -1,
      dialogDelete: false,
      sponsorForm,
      form: Object.assign({}, sponsorForm),
      sponsorItems: [],
      defaultItem: {
        name: "",
        website: "",
        year: null,
        contact: ""
      },
      userId: "",
      buttonColor: "#fff",
      cardBGColor: "#f1f1f1",
      participantList: [],
      bandLoadingParticipants: false
    };
  },
  created(){
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.cardBGColor = this.$store.getters.env.get('VUE_APP_BACKGROUND_CARD_PART');
    this.borderAlertColor = this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR');
    this.iconAlertColor = this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR');
    this.bgAlertColor = this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR');
  },
  mounted() {
    this.$emit("titlePage", "sponsors.title");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);
    this.getParticipants();
  },
  computed: {
    sponsorFormIsValid() {
      return (
        this.form.name
      );
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("sponsors.create_sponsor")
        : this.$t("sponsors.edit_sponsor");
    },
    btnTitle() {
      return this.editedIndex === -1
        ? this.$t("sponsors.create")
        : this.$t("sponsors.edit");
    },
    sponsorHeaders() {
      return [
        {
          text: this.$t("sponsors.name"),
          align: "",
          sortable: false,
          value: "name"
        },
        { text: this.$t("sponsors.website"), value: "website" },
        { text: this.$t("sponsors.year"), value: "year" },
        { text: this.$t("sponsors.contact"), value: "contact" },
        {
          text: this.$t("sponsors.actions"),
          value: "actions",
          sortable: false
        }
      ];
    },
    ...mapState({
      content2(state) {
        return this.$t("common.selectParticipants.content_2", { livelapsId: state.session.userid })
      },
      age18: (state) => state.session.age18,
      userStore: (state) => state.session.user,
      participants: (state) => state.session.participants,
      participant: (state) => state.session.participantsSelected
    }),
    rules() { 
      return {
        name: [
          val => this.$inputRules({ value: val }, 'filled') || this.$t("sponsors.name_required"),
          val => this.$inputRules({ value: val, minSize: 1, maxSize: 250 }, 'fieldLength') || this.$t("sponsors.max_length_name")
        ]
      };
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    userStore(val) {
      if(val) {
        this.getParticipants();
      }
    },
    participant() {
      if(!this.bandLoadingPartSelected) {
        this.bandLoadingPartSelected = true;
        this.selectParticipants();
      }
    }
  },
  methods: {
    loadImage(url) {
        const urlImage = GeneralService.cleanImage(url, this.$store.getters.env.get('VUE_APP_IMAGE_PLACEHOLDER'));
        return urlImage;
    },
    selectParticipants(){ 
      this.participantList = this.participantList.filter((el) => {
        const find = this.participant.find((ele) => { 
          return ele.userId ? el.userId == ele.userId : el.id == ele.id
        });
        return find ? true : false;
      });
      const usersId = this.participant.map((el) => { return el.userId; });
      this.getSponsorsUsers(usersId);
      AuthService.setAuthParticipants(this.userStore.id, this.participant); 
    },
    async getParticipants(){
      if(!this.bandLoadingParticipants) {
        if(this.userStore) {
          this.bandLoadingParticipants = true;
          this.$store.dispatch('setParticipantsAction');  
        } else {
          this.$store.dispatch('setUserAction');
        }
      }
    },
    openDialogCreate(userId){
      this.form.userId = userId;
      if(this.$refs.form)
        this.$refs.form.resetValidation();
      this.dialog = true;
    },
    showSnackBar(msg, color){
      this.snackbar = true;
      this.msg_snackbar = msg;
      this.color_snackbar = color;
      setTimeout(() => this.snackbar = false, 3000);
    },
    getSponsors(userId) {
      let sponsors = [];
      SponsorService.getAll(userId).then(response => {
        if (response.data.success == 1) {
          response.data.message.map(function(value) {
            sponsors.push({
              id: value.id,
              name: value.name,
              year: value.year,
              website: value.website,
              contact: value.contact,
              userId: value.userId
            });
          });
        }
      });
      this.sponsorItems = sponsors;
    },
    getSponsorsUsers(usersId) {
      SponsorService.getSponsorsUsers({usersId}).then((response) => {
        this.participantList = this.participant.map((el) => {
            const filter = response.data.message.filter((el1) => el.userId == el1.userId);
            return {
              ...el, 
              sponsors: filter.map((value) => {
                return {
                  id: value.id,
                  name: value.name,
                  year: value.year,
                  website: value.website,
                  contact: value.contact,
                  userId: value.userId
                };
              })
            }
          });
      });
    },
    setSponsor(data) {
      SponsorService.create(data).then(response => {
        if (response.data.success == 1) {
          this.sponsorItems = [];
          this.selectParticipants();
          this.showSnackBar(this.$t("sponsors.msg_success_created"), "success");
          this.close();
        }else{
          this.showSnackBar(this.$t("sponsors."+response.data.message), "error");
        }
      });
    },
    deleteSponsor(id) {
      SponsorService.delete(this.form.userId, id).then(response => {
        if (response.data.success == 1) {
          this.sponsorItems = [];
          this.selectParticipants();
          this.showSnackBar(this.$t("sponsors.msg_success_deleted"), "success");
        }else{
          this.showSnackBar(this.$t("sponsors."+response.data.message), "error");
        }
      });
    },
    editSponsor(data) {
      SponsorService.update(data).then(response => {
        if (response.data.success == 1) {
          this.sponsorItems = [];
          this.selectParticipants();
          this.showSnackBar(this.$t("sponsors.msg_success_edited"), "success");
          this.close();
        }else{
          this.showSnackBar(this.$t("sponsors."+response.data.message), "error");
        }
      });
    },
    editItem(item) {
      this.editedIndex = item.id;
      this.form = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = item.id;
      this.form = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.deleteSponsor(this.form.id);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    createSponsor() {
      if(!this.$refs.form.validate()) {
        return;
      }
      let obj = {
        'userId': this.form.userId,
        'name': this.form.name
      };
      if(this.form.website != '' && this.form.website != null)
        obj.website = this.form.website;
      if(this.form.contact != '' && this.form.contact != null)
        obj.contact = this.form.contact;
      if(this.form.year != '' && this.form.year != null)
        obj.year = this.form.year;

      if (this.editedIndex > -1) {
        obj.id = this.form.id;
        this.editSponsor(obj);
      } else {
        this.setSponsor(obj);
      }
    },
    changeSelect(selectParts) {
      this.$store.commit('setParticipantsSelected', selectParts);
    }
  }
};
</script>
<style>
.sponsors .v-data-table-header{
  background: #ccc;
}
.sponsors .v-card__title {
  background: #ccc;
}
.mt16 {
  margin-top: 16px;
}
.btn{
  color: #fff !important;
}
.partImg{
  width: 40px;
  border-radius: 50%;
  height: 40px;
}
.partSpan{
  color: #000;
  position: absolute;
  top: 10px;
  left: 60px;
}
.v-card__actions{
  display: inherit;
  text-align: right;
}
</style>
